import { useEffect, useRef } from "react";

export const useBarcodeScanner = (onScan, timeout = 50) => {
  const buffer = useRef("");
  const lastTime = useRef(Date.now());

  useEffect(() => {
    const handleKeyDown = (e) => {
      const now = Date.now();

      // reset buffer if slow typing (human)
      if (now - lastTime.current > timeout) {
        buffer.current = "";
      }

      lastTime.current = now;

      // ENTER = barcode end
      if (e.key === "Enter") {
        if (buffer.current.length >= 3) {
          onScan(buffer.current);
        }
        buffer.current = "";
        return;
      }

      // accept only numbers & letters
      if (/^[a-zA-Z0-9]$/.test(e.key)) {
        buffer.current += e.key;
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onScan, timeout]);
};
